import { mountAll, resolveCdnBase } from './mount';
import { warnOnce } from './warn';

/**
 * The embed entry point.
 *
 * Host page contract:
 *
 *   <div data-quizee="int_0195..."></div>
 *   <script src="https://cdn.quizee.io/embed.js" async></script>
 *
 * `document.currentScript` is only correct while the script is executing, so it is read on the
 * first line and never again. Everything after that is wrapped: a publisher's page must not be
 * able to break because of us.
 */
const currentScript =
  typeof document === 'undefined'
    ? null
    : ((document.currentScript as HTMLScriptElement | null) ??
      document.querySelector<HTMLScriptElement>('script[src*="embed.js"]'));

function boot(): void {
  try {
    mountAll({
      win: window,
      cdnBase: resolveCdnBase(currentScript, document.location.href),
    });
  } catch (error) {
    warnOnce('the embed could not start', error);
  }
}

try {
  if (document.readyState === 'loading') {
    // An async script can still beat the parser to an embed further down the page.
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
} catch (error) {
  warnOnce('the embed could not start', error);
}
